import React, { Component } from 'react';

import './empresaPlan.css';
import '../consumoHome.css';

import LogoEmpresaPlan from '../../../../img/logoEmpresaEjemplo.png';

class EmpresaPlan extends Component {

    constructor(){
        super();
        this.state = {
            
        };
    }

    render(){
        return(
            <div className='col s12'>
                <div className="card-panel cardConsumo empresaPlanCard">
                    <p className='tituloHeader'>Empresa</p>
                    <div className='infoEmpresaPlan'>
                        <div className='logoEmpresaPlan'>
                            <img src={LogoEmpresaPlan} alt='logoEmpresaPlan' />
                        </div>
                        <div className='datosEmpresaPlan'>
                            <p>i-Strategies</p>
                            <p>Plan Básico</p>
                            <div className='btnCambiarPlan'>
                                <p>Cambiar de Plan</p>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default EmpresaPlan;
